import { render } from "./PermissionTable.vue?vue&type=template&id=7ebf4d02&scoped=true"
import script from "./PermissionTable.vue?vue&type=script&lang=ts"
export * from "./PermissionTable.vue?vue&type=script&lang=ts"

import "./PermissionTable.vue?vue&type=style&index=0&id=7ebf4d02&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7ebf4d02"

export default script